import React from 'react';
import { ReactComponent as GoogleIcon } from 'qs-assets/Media/ic_google_outline.svg';
import './styles.scss';

export default ({ width, height, fill, classes = '' }) => {
  return (
    <GoogleIcon style={{ width, height, fill }} className={`settingsIconComponent ${classes}`} />
  );
};
